// src/components/FloatingPawButton.js
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import "../styles/ChatTheme.css";

export default function FloatingPawButton({ isAuthenticated, hasActiveSub }) {
  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname || "";
  const isOnFound = path.startsWith("/found");

  // 🔒 Hide if:
  // - not logged in
  // - not subscribed
  // - OR on public /found route
  if (!isAuthenticated || !hasActiveSub || isOnFound) {
    return null;
  }

  // Optional: hide on profile itself (if you don’t want it there)
  // const isOnProfile = path.startsWith("/profile");
  // if (isOnProfile) return null;

  const handleClick = () => {
    navigate("/profile");
  };

  return (
    <button
      className="paw-float-btn"
      onClick={handleClick}
      title="Back to Overview"
    >
      <FontAwesomeIcon icon={faUser} />
    </button>
  );
}
